module.exports = __webpack_public_path__ + "img/Pic_LT_H.9bda99f0.png";